import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError, timer } from 'rxjs';

import { Request } from '../request/shared/request.model';
import { Response } from '../response/shared/response.model';

import getBaseUrl from '../BaseUrl';
import { ClientTokenService } from '../clienttoken.service';
import { catchError, retry, retryWhen, delayWhen, take } from 'rxjs/operators';
import { delay } from 'q';

@Injectable()
export class ErnstWebService {
  clientToken: string;
  constructor(
    private http: HttpClient,
    private clientTokenService: ClientTokenService
  ) {
    clientTokenService.clientToken$.subscribe(
      clientToken => (this.clientToken = clientToken)
    );
  }

  submit(request: Request): Observable<Response> {
    const url = `${getBaseUrl()}api/request`;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.clientToken}`,
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<Response>(url, request, httpOptions).pipe(
      retryWhen(errors =>
        errors.pipe(
          delayWhen(() => timer(1000)),
          take(2)
        )
      ),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Code ${error.status}, ` + `Body: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('An error occurred processing the transaction.');
  }
}
